import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

import { MesoTrigger } from 'components/meso/meso-trigger';

interface MesoNativeResultListingProps {
  uci: string;
  className: string;
  errorBoundaryLabel?: string;
}

export const MesoNativeResultListing: React.FunctionComponent<MesoNativeResultListingProps> = props => {
  const [adServed, setAdServed] = React.useState(false);

  const adRef = React.useRef(null);

  React.useEffect(() => {
    const node = adRef.current;

    if (node) {
      node.addEventListener('mesoAd', e => {
        if (e && e.detail) {
          if (e.detail.code === 'AD-LOAD-PASS') {
            setAdServed(true);
          }
          if (e.detail.code === 'AD-LOAD-FAIL') {
            setAdServed(false);
          }
        }
      });
    }
  }, []);

  const { errorBoundaryLabel, uci, className } = props;

  return (
    <ErrorBoundary label={errorBoundaryLabel}>
      <li data-stid="native-results-listing" className={adServed ? className : ''}>
        <AbacusExperiment name="PWA_MESO_NRL_Test">
          <AbacusControl>
            <meso-native-results-listing ref={adRef} uci={uci} />
          </AbacusControl>
          <AbacusVariant bucket={1}>
            <meso-native-results-listing ref={adRef} uci={uci + '1'} />
          </AbacusVariant>
          <AbacusVariant bucket={2}>
            <meso-native-results-listing ref={adRef} uci={uci + '2'} />
          </AbacusVariant>
          <AbacusVariant bucket={3}>
            <meso-native-results-listing ref={adRef} uci={uci + '3'} />
          </AbacusVariant>
          <AbacusVariant bucket={4}>
            <meso-native-results-listing ref={adRef} uci={uci} />
          </AbacusVariant>
        </AbacusExperiment>
      </li>
      <MesoTrigger pageName="page.Hotels.Search" />
    </ErrorBoundary>
  );
};
MesoNativeResultListing.displayName = 'MesoNativeResultListing';

MesoNativeResultListing.defaultProps = {
  errorBoundaryLabel: 'hotel.meso'
};
